const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? '' // Vercel will handle the API routes automatically
    : 'http://localhost:5000');

export const apiUrl = (path: string) => `${API_BASE_URL}${path}`;
